import { mapObjIndexed, cond, is, tryCatch, always, T, identity } from 'ramda'

export default keyMappers => baseObject => ({
  // first put in all the keys that came in the base object
  ...baseObject,
  // loop over all the keyMappers and use to process
  // or overwrite values from the baseObject.
  ...mapObjIndexed(
    cond([
      [
        // if our key mapper is a function, then
        // try to run the function by passing the full object
        // to it. If it fails, just return undefined.
        is(Function),
        tryCatch(keyMapper => keyMapper(baseObject), always(undefined)),
      ],
      [T, identity],
    ]),
    keyMappers,
  ),
})
